var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
  function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value) }) }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) { try { step(generator.next(value)) } catch (e) { reject(e) } }
    function rejected(value) { try { step(generator["throw"](value)) } catch (e) { reject(e) } }
    function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected) }
    step((generator = generator.apply(thisArg, _arguments || [])).next())
  })
}
import Service from './service'
export var ApiCameraMessageType;
(function (ApiCameraMessageType) {
  ApiCameraMessageType["CAMERA_CONTROL_ERROR"] = "camera.control.error"
  ApiCameraMessageType["CAMERA_CONTROL_REQUEST"] = "camera.control.request"
  ApiCameraMessageType["CAMERA_CONTROL_RESPONSE"] = "camera.control.response"
})(ApiCameraMessageType || (ApiCameraMessageType = {}))
export var CameraMessageType;
(function (CameraMessageType) {
  CameraMessageType["CAMERA_START"] = "CAMERA_START"
  CameraMessageType["CAMERA_ERROR"] = "CAMERA_ERROR"
})(CameraMessageType || (CameraMessageType = {}))
/**
 * Сервис для работы с камерой
 * @version 0.0.1
 * @since 1.10.0
 */
export default class CameraService extends Service {
  /**
     * @ignore
     */
  constructor(messageChannel) {
    super(messageChannel)
    const messageHandler = (message) => {
      switch (message.type) {
        case ApiCameraMessageType.CAMERA_CONTROL_RESPONSE:
          if (typeof message.start_camera !== 'undefined') {
            if (message.start_camera === true) {
              this.resolve(this.waiters.camera, true)
            }
            else {
              this.reject(this.waiters.camera, message.reason)
            }
          }
          else if (typeof message.make_photo !== 'undefined') {
            if (message.make_photo === true) {
              this.resolve(this.waiters.photo, message.file)
            }
            else {
              this.reject(this.waiters.photo, message.reason)
            }
          }
          break
        case ApiCameraMessageType.CAMERA_CONTROL_ERROR:
          this.broadcast(CameraMessageType.CAMERA_ERROR, message.error)
          break
      }
    }
    this.waiters = {
      camera: [],
      photo: [],
    }
    this.messageChannel.subscribe(ApiCameraMessageType.CAMERA_CONTROL_RESPONSE, messageHandler)
    this.messageChannel.subscribe(ApiCameraMessageType.CAMERA_CONTROL_ERROR, messageHandler)
  }
  /**
     * Произошла попытка запустить камеру
     * @since 1.10.0
     *
     * @param {() => void} callback
     * @return {*}  {UnsubscribeFunction}
     * @memberof CameraService
     *
     * @example <caption>Произошла попытка запустить камеру</caption>
     * robot.audioService.onCameraStart(() => {
     *   ...
     * })
     */
  onCameraStart(callback) {
    return this.subscribe(CameraMessageType.CAMERA_START, callback)
  }
  /**
     * Сервис камеры прислал ошибку
     * @since 1.10.0
     *
     * @param {(error: string) => void} callback
     * @return {*}  {UnsubscribeFunction}
     * @memberof CameraService
     *
     * @example <caption>Сервис камеры прислал ошибку</caption>
     * robot.audioService.onCameraError((error) => {
     *   ...
     * })
     */
  onCameraError(callback) {
    return this.subscribe(CameraMessageType.CAMERA_ERROR, callback)
  }
  /**
     * Остановить камеру
     * @since 1.10.0
     *
     * @memberof CameraService
     *
     * @example <caption>Остановить камеру</caption>
     * robot.cameraService.stopCamera()
     */
  stopCamera() {
    this.messageChannel.send({
      type: ApiCameraMessageType.CAMERA_CONTROL_REQUEST,
      stop_camera: '',
    })
  }
  /**
     * Запустить камеру
     * @since 1.10.0
     *
     * @return {*}  {Promise<void>}
     * @memberof CameraService
     *
     * @example <caption>Запустить камеру</caption>
     * robot.cameraService.startCamera().then(() => {
     *   console.log('OK')
     * }).catch(reason => { console.log(reason) })
     */
  startCamera() {
    return __awaiter(this, void 0, void 0, function* () {
      this.broadcast(CameraMessageType.CAMERA_START)
      return this.execute({
        type: ApiCameraMessageType.CAMERA_CONTROL_REQUEST,
        start_camera: '',
      }, this.waiters.camera)
    })
  }
  /**
     * Сделать фото
     * @since 1.10.0
     * При успехе возвращает полный путь до файла
     *
     * @return {*}  {Promise<string>}
     * @memberof CameraService
     *
     * @example <caption>Сделать фото</caption>
     * robot.cameraService.makePhoto().then((filename) => {
     *   console.log('photofullpath', filename)
     * }).catch(reason => { console.log(reason) })
     */
  makePhoto() {
    return __awaiter(this, void 0, void 0, function* () {
      return this.execute({
        type: ApiCameraMessageType.CAMERA_CONTROL_REQUEST,
        make_photo: '',
      }, this.waiters.photo)
    })
  }
}
